import { createSelector } from 'reselect';

import { getProps } from 'utils/selectors';

/** @return {import("../reducers").ScreensaverReducer} */
const getState = state => state.screensaver;

const getDataState = createSelector(getState, state => state.data);

export const getDataIds = createSelector(getDataState, state => state.ids);

export const getDataEntities = createSelector(getDataState, state => state.entities);

export const getScreensaverById = createSelector(
  getDataEntities,
  getProps,
  (entities, screensaverId) => entities[screensaverId]
);

export const getScreensaverByIds = createSelector(getDataEntities, getProps, (entities, screensaverIds) =>
  screensaverIds.reduce((acc, screensaverId) => {
    const exists = Boolean(entities[screensaverId]);
    if (exists) {
      return [...acc, entities[screensaverId]];
    }
    return acc;
  }, []));

export const getUIState = createSelector(getState, state => state.ui);
